// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RemoveTagFromDataItemRequestModel from '../../model/remove-tag-from-data-item-request-model';
import RemoveTagFromDataItemRequestDTO from '../dto/remove-tag-from-data-item-request-dto';
import dtoSchema from '../schemas/remove-tag-from-data-item-request-schema';

export default abstract class RemoveTagFromDataItemRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RemoveTagFromDataItemRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.tagId = data.tagId;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int64}
  */
  tagId?: number;

  static toModel(dto: DeepPartial<RemoveTagFromDataItemRequestDTO>): RemoveTagFromDataItemRequestModel;
  static toModel(dto: DeepPartial<RemoveTagFromDataItemRequestDTO> | undefined | null): RemoveTagFromDataItemRequestModel | undefined;
  static toModel(dto: DeepPartial<RemoveTagFromDataItemRequestDTO> | undefined | null): RemoveTagFromDataItemRequestModel | undefined {
    return dto ? new RemoveTagFromDataItemRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RemoveTagFromDataItemRequestModel> | RemoveTagFromDataItemRequestModel): RemoveTagFromDataItemRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      tagId: unwrapped.tagId,
    } as RemoveTagFromDataItemRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RemoveTagFromDataItemRequestModel, can not map to RemoveTagFromDataItemRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
